import React from "react";
import { Inner } from "./styles";
import { Input } from "antd";

export default function ProductDiscount({ product, onChange }) {
	const handleChange = (e) => {
		if (e.target.value <= 0) {
			e.target.value = 0;
			e.target.setSelectionRange(0, 0);
			e.target.focus();
			e.target.select();
		}
		if (e.target.value >= 99) e.target.value = 99;
		const onlyPositiveInteger = /^[0-9]*\.?[0-9]{0,2}$/;
		if (onlyPositiveInteger.test(e.target.value))
			onChange({ index: product.index, value: e.target.value });
	};

	const handleFocus = (event) => event.target.select();

	return (
		<Inner>
			<Input
				value={product.discount}
				onChange={handleChange}
				onFocus={handleFocus}
			/>
		</Inner>
	);
}
